import { api } from '../api';
import { PageHead, Panel, State, Table, useLoad } from '../ui';

/**
 * Where to go and recruit.
 *
 * Phase 0 measured hyperlocal supply mattering more than any algorithm change:
 * an unmanaged pool matched 15.8% of riders, the same riders matched 40.0% once
 * drivers were concentrated on their corridors. So this table is a growth
 * instruction, not a report — the top row is the next place to find drivers.
 */
export function Supply() {
  const { data, error, loading, reload } = useLoad(() => api.supplyGaps());
  const rows = data ?? [];
  const totalRiders = rows.reduce((n, r) => n + Number(r.riders), 0);
  const totalUnmatched = rows.reduce((n, r) => n + Number(r.unmatched), 0);

  return (
    <>
      <PageHead
        title="Supply gaps"
        blurb="Riders with a locked route and no driver on it, by office. The top row is where recruiting a single driver helps the most people."
      />

      {data ? (
        <dl className="stats">
          <div className="stat">
            <dt>Rider routes</dt>
            <dd>{totalRiders}</dd>
          </div>
          <div className={`stat${totalUnmatched > 0 ? ' act' : ''}`}>
            <dt>Unmatched</dt>
            <dd>{totalUnmatched}</dd>
          </div>
          <div className="stat">
            <dt>Overall match rate</dt>
            <dd>
              {totalRiders === 0
                ? '—'
                : `${Math.round((100 * (totalRiders - totalUnmatched)) / totalRiders)}%`}
            </dd>
          </div>
          <div className="stat">
            <dt>Phase 5 target</dt>
            <dd>70<small>%</small></dd>
          </div>
        </dl>
      ) : null}

      <Panel
        title="By office"
        right={
          <button className="btn sm" onClick={() => void reload()} disabled={loading}>
            Refresh
          </button>
        }
      >
        {error ? <div className="empty">{error}</div> : (
          <Table
            rows={data}
            keyOf={(r) => r.office ?? 'unassigned'}
            empty="No rider routes locked yet."
            columns={[
              { head: 'Office', cell: (r) => r.office ?? 'Unassigned' },
              { head: 'Riders', num: true, shrink: true, cell: (r) => r.riders },
              { head: 'Matched', num: true, shrink: true, cell: (r) => r.matched },
              {
                head: 'Unmatched',
                num: true,
                shrink: true,
                cell: (r) =>
                  Number(r.unmatched) > 0
                    ? <strong style={{ color: 'var(--warn)' }}>{r.unmatched}</strong>
                    : r.unmatched,
              },
              {
                head: 'Match rate',
                num: true,
                shrink: true,
                cell: (r) =>
                  r.match_rate_pct == null ? '—' : (
                    <State tone={Number(r.match_rate_pct) >= 70 ? 'ok' : 'warn'}>
                      {r.match_rate_pct}%
                    </State>
                  ),
              },
            ]}
          />
        )}
      </Panel>
    </>
  );
}
